module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(1);

	var angular = __webpack_require__(2);

	var MODULE_NAME = 'rediWorkspacesWebLib';

	var angularModule = angular.module(MODULE_NAME, [
	  'redi-common',
	  __webpack_require__(3)
	]);

	__webpack_require__(4)(angularModule);
	__webpack_require__(9)(angularModule);

	module.exports = MODULE_NAME;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = require("redi-common-angular");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = require("angular");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = require("redi-window-container-web-lib-angular");

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var workspaceWebLib = __webpack_require__(5);

	module.exports = function (angularModule) {
	  angularModule
	      .service('defaultsRepository', __webpack_require__(6))
	      .factory('Workspace', function () {
	        return workspaceWebLib.Workspace;
	      })
	      .factory('workspaceService', __webpack_require__(8))
	      .factory('WorkspaceWindow', function () {
	        return workspaceWebLib.WorkspaceWindow;
	      });
	};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = require("redi-workspaces-web-lib");

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(7);

	module.exports = /* @ngInject */ ["workspaceApiFactory", function (workspaceApiFactory) {
	  var that = this;

	  var createDefaultsApi = function () {
	    return workspaceApiFactory.create().then(function (api) {
	      return api.all('defaults');
	    });
	  };

	  that.get = function (windowType, filter) {
	    var params = createParams(windowType, filter);
	    return createDefaultsApi().then(function (api) {
	      return api.customGET('window', params);
	    });
	  };

	  that.set = function (windowType, filter, defaults) {
	    var params = createParams(windowType, filter);
	    return createDefaultsApi().then(function (api) {
	      return api.customPUT(defaults, 'window', params);
	    });
	  };

	  that.reset = function (windowType, filter) {
	    var params = createParams(windowType, filter);
	    return createDefaultsApi().then(function (api) {
	      return api.customDELETE('window', params);
	    });
	  };

	  function createParams(windowType, filter) {
	    return _.defaults({type: windowType}, filter);
	  }
	}];


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = require("lodash");

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var workspaceWebLib = __webpack_require__(5);
	var localWorkspaceRepository = workspaceWebLib.localWorkspaceRepository;
	var localWorkspaceWindowRepository = workspaceWebLib.localWorkspaceWindowRepository;

	module.exports = /* @ngInject */ ["$q", "$window", "workspaceApiFactory", "Workspace", "$log", "OPENFIN_WINDOW_DEFAULT_LAYOUT", "DEFAULT_CONFIGURATION", "WORKSPACE_DATA_VERSION", function ($q,
	                                           $window,
	                                           workspaceApiFactory,
	                                           Workspace,
	                                           $log,
	                                           OPENFIN_WINDOW_DEFAULT_LAYOUT,
	                                           DEFAULT_CONFIGURATION,
	                                           WORKSPACE_DATA_VERSION) {
	  function getDefaultLayout() {
	    return OPENFIN_WINDOW_DEFAULT_LAYOUT;
	  }

	  function getDefaultData() {
	    return {
	      configuration: DEFAULT_CONFIGURATION,
	      version: WORKSPACE_DATA_VERSION
	    };
	  }

	  function getOrCreateWorkspaceFromLocalStorage() {
	    return localWorkspaceRepository.getOrCreate();
	  }

	  function setLocalWorkspace(workspaceServerModel) {
	    localWorkspaceRepository.set(new Workspace(workspaceServerModel));
	  }

	  function clearWorkspaceFromStorage() {
	    localWorkspaceRepository.clear();
	  }

	  function getOrCreateWorkspace() {
	    return $q.when(getOrCreateWorkspaceFromLocalStorage());
	  }

	  function getOrCreateWorkspaceByName(workspaceName, workspaceOwnerOrNull) {
	    return workspaceApiFactory.create().then(function (workspaceApi) {
	      var queryParams = {name: workspaceName, owner: workspaceOwnerOrNull};
	      return workspaceApi.all('workspaces').customGETLIST('', queryParams)
	          .then(function (workspaces) {
	            if (workspaces.length !== 0) {
	              return new Workspace(workspaces[0].plain());
	            }
	          }, function (response) {
	            if (response.status === 404) {
	              $log.error('Did not find workspace by name: ' + workspaceName + ' from server. Creating a new one...');
	              return workspaceApi.all('workspaces').post({name: workspaceName}).then(function (response) {
	                return new Workspace(response.plain());
	              });
	            } else {
	              $log.error('Error in getting data from server for workspace: ' + workspaceName);
	            }
	          });
	    });
	  }

	  function isExistingWorkspaceWindow(type, name) {
	    return localWorkspaceWindowRepository.isExisting(type, name);
	  }

	  function getOrCreateDefaultWindow(type) {
	    return localWorkspaceWindowRepository.getOrCreate(type, getDefaultLayout(), getDefaultData());
	  }

	  function setWindow(workspaceWindow) {
	    localWorkspaceWindowRepository.set(workspaceWindow);
	  }

	  function saveWorkspaceWithoutWindows(workspaceName) {
	    return getOrCreateWorkspaceByName(workspaceName).then(
	        function (workspaceFromServer) {
	          if (workspaceFromServer) {
	            var workspaceToSave = new Workspace({name: workspaceName, id: workspaceFromServer.getId()});
	            return saveExistingWorkspace(workspaceToSave).then(function (response) {
	              return new Workspace(response.plain());
	            });
	          }
	        });
	  }

	  function saveExistingWorkspace(workspace) {
	    return workspaceApiFactory.create().then(function (workspaceApi) {
	      return workspaceApi.one('workspaces', workspace.getId()).customPUT(workspace.serverModel());
	    });
	  }

	  return {
	    getDefaultLayout: getDefaultLayout,
	    getDefaultData: getDefaultData,
	    getOrCreateWorkspace: getOrCreateWorkspace,
	    getOrCreateWorkspaceByName: getOrCreateWorkspaceByName,
	    getOrCreateDefaultWindow: getOrCreateDefaultWindow,
	    setLocalWorkspace: setLocalWorkspace,
	    setWindow: setWindow,
	    clearWorkspaceStoredLocally: clearWorkspaceFromStorage,
	    saveExistingWorkspace: saveExistingWorkspace,
	    saveWorkspaceWithoutWindows: saveWorkspaceWithoutWindows,
	    isExistingWorkspaceWindow: isExistingWorkspaceWindow
	  };
	}];


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = function (angularModule) {
	  angularModule
	      .constant('OPENFIN_WINDOW_DEFAULT_LAYOUT', { // Override if not suitable.
	        left: 0,
	        top: 50,
	        width: 1280,
	        height: 600
	      })
	      .constant('DEFAULT_CONFIGURATION', {}) // To be overridden
	      .constant('WORKSPACE_API_BASE', '/workspaces/webapi')
	      .constant('WORKSPACE_DATA_VERSION', '1.0.0') // To be overridden
	      .service('workspaceApiFactory', __webpack_require__(10));
	};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = /* @ngInject */ ["apiFactory", "WORKSPACE_API_BASE", function (apiFactory, WORKSPACE_API_BASE) {
	  function configurator(RestangularConfigurer) {
	    RestangularConfigurer.setDefaultHeaders({'Content-Type': 'application/json'});
	  }

	  this.create = function () {
	    return apiFactory.create('workspaceAddress', WORKSPACE_API_BASE, configurator);
	  };
	}];


/***/ })
/******/ ]);


//////////////////
// WEBPACK FOOTER
// /app/~/redi-workspaces-web-lib-angular/dist/bundle.js
// module id = 132
// module chunks = 0